var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(-0.31 0.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2854",
    "data-name": "Rectangle 2854",
    width: 62,
    height: 40,
    rx: 4,
    transform: "translate(0.31 -0.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569",
    transform: "translate(9.88 13.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M49.519,90.291l3.805-12.547h3.4L52.914,90.291ZM48,77.748l-3.054,5.319A12.9,12.9,0,0,0,43.5,86.043h-.047c.054-1.115-.1-2.486-.116-3.26L43,77.748H37.28l-.058.338A2.369,2.369,0,0,1,39.8,80.332l1.114,9.96h3.518l7.113-12.544Zm26.4,12.544-.094-1.866-4.239,0L69.2,90.291H65.519L72.2,77.768h4.524l1.132,12.523Zm-.389-7.4a28.824,28.824,0,0,1-.007-2.948h-.05c-.206.623-1.094,2.494-1.484,3.413l-1.263,2.75h2.977ZM60.284,90.648a9.491,9.491,0,0,1-5.123-1.439l1.617-2.47a6.272,6.272,0,0,0,3.663,1.228,1.576,1.576,0,0,0,1.487-.715c.472-.816-.109-1.255-1.435-2.006l-.655-.426c-1.966-1.343-2.817-2.62-1.891-4.847.593-1.425,2.154-2.5,4.732-2.5a7.6,7.6,0,0,1,4.414,1.52L65.233,81.17A4.131,4.131,0,0,0,62.6,80.016a1.584,1.584,0,0,0-1.449.649c-.354.7.115,1.178,1.148,1.82l.779.5c2.388,1.506,2.956,3.084,2.358,4.56-1.03,2.541-3.045,3.108-5.152,3.108Zm18.586-11.2h-.147v-.9h.34c.216,0,.326.076.326.257a.228.228,0,0,1-.233.244l.251.393H79.24l-.231-.382H78.87v.382Zm.164-.508c.11,0,.208-.011.208-.14,0-.108-.106-.121-.194-.121H78.87v.262Zm0,.855a.809.809,0,1,1,.791-.809A.779.779,0,0,1,79.03,79.791Zm0-1.477a.67.67,0,1,0,.618.668A.628.628,0,0,0,79.03,78.314Z",
    transform: "translate(-37.222 -77.469)",
    fill: "#1d5b99",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2856",
    "data-name": "Rectangle 2856",
    d: "M0,0H62a0,0,0,0,1,0,0V5a4,4,0,0,1-4,4H4A4,4,0,0,1,0,5V0A0,0,0,0,1,0,0Z",
    transform: "translate(0.31 30.424)",
    fill: "#e7a83a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2857",
    "data-name": "Rectangle 2857",
    d: "M4,0H58a4,4,0,0,1,4,4V9a0,0,0,0,1,0,0H0A0,0,0,0,1,0,9V4A4,4,0,0,1,4,0Z",
    transform: "translate(0.31 -0.576)",
    fill: "#1d5b99"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.aa9d6d3162ef73d85aeb1281d8aa1362.svg";
export { ForwardRef as ReactComponent };